import {http} from '@/src/services/config/config-receituario'

export default{
    information:(token)=>{
        return http.get('overview-info', {
            headers:{
                'Authorization':token
            }
        })
       
    },
}